var HeroBannerWithVideo = (function () {
    var config = {
        modalVideoSelector: ".modal-video",
        bodyVideoClass: "has-videocontainer",
        modalEventShown: "shown.bs.modal",
        modalEventHidden: "hidden.bs.modal",
        youTubeVideoSelector: null,
        html5VideoSelector: null,
        resizeTimeout: null,
    };

    function HeroBannerWithVideo() {
        //method intentionally left empty
    }

    HeroBannerWithVideo.prototype.init = function () {
        var self = this;

        // Add class to body if .videocontainer exists
        if ($(config.modalVideoSelector).length > 0) {
            $("body").addClass(config.bodyVideoClass);
        }

        self.bindEvents();
        self.autoplayVideosOnLoad();
    };

    HeroBannerWithVideo.prototype.bindEvents = function () {
        var self = this;

        // Bind events for modals
        $(config.modalVideoSelector).on(config.modalEventShown, function (e) {
            self.onModalShown(e);
        });

        $(config.modalVideoSelector).on(config.modalEventHidden, function (e) {
            self.onModalHidden(e);
        });

        // Bind events for window resize
        $(window).on("resize", function () {
            //clear timeout
            clearTimeout(config.resizeTimeout);

            //set timeout
            config.resizeTimeout = setTimeout(function () {
                self.setYouTubeWidthAndHeight();
                self.setHtml5VideoWidthAndHeight();
            }, 400);
        });
    };

    HeroBannerWithVideo.prototype.onModalShown = function (e) {
        var self = this;
        var modal = $(e.target);
        var video = modal.find("video");
        var iframe = modal.find("iframe");
        if (video.length > 0) {
            video[0].play();
            self.html5VideoSelector = video;
            self.setHtml5VideoWidthAndHeight();
        } else if (iframe.length > 0) {
            self.youTubeVideoSelector = iframe;
            self.setYouTubeWidthAndHeight();
        }
    };

    HeroBannerWithVideo.prototype.setHtml5VideoWidthAndHeight = function () {
        var self = this;
        if (!self.html5VideoSelector) {
            return;
        }

        self.setVideoDimensions(self.html5VideoSelector);
    };

    HeroBannerWithVideo.prototype.setYouTubeWidthAndHeight = function () {
        var self = this;
        if (!self.youTubeVideoSelector) {
            return;
        }

        self.setVideoDimensions(self.youTubeVideoSelector);
    };

    HeroBannerWithVideo.prototype.setVideoDimensions = function (element) {
        var windowWidth = $(window).width() - 40;
        var windowHeight = $(window).height() - 110;
        var aspectRatio = 16 / 9;
        var newWidth = windowWidth;
        var newHeight = windowWidth / aspectRatio;

        if (newHeight > windowHeight) {
            newHeight = windowHeight;
            newWidth = windowHeight * aspectRatio;
        }

        element.css({
            width: newWidth,
            height: newHeight
        });
    };

    HeroBannerWithVideo.prototype.onModalHidden = function (e) {
        this.stopVideoAndIframe(e);
    };

    HeroBannerWithVideo.prototype.stopVideoAndIframe = function (e) {
        var modal = $(e.target);
        var video = modal.find("video");
        var iframe = modal.find("iframe");

        if (video.length > 0) {
            video[0].pause();
            video[0].currentTime = 0;
        } else if (iframe.length > 0) {
            var youtubeSrc = $(iframe).attr("src");
            $(iframe).attr("src", "");
            $(iframe).attr("src", youtubeSrc);
            self.youTubeVideoSelector = null;
        }
    };

    HeroBannerWithVideo.prototype.autoplayVideosOnLoad = function () {
        // Autoplay videos with autoplay attribute on page load

        $("video[autoplay]").each(function () {
            this.play();
        });
    };

    return HeroBannerWithVideo;
})();

// Initialize the class when the document is ready
$(document).ready(function () {
    if ($(".modal-video").length > 0) {
        new HeroBannerWithVideo().init();
    }
});